// CONSTANTS are all caps.
const NS = 'DirectionsBlock';
const CLS = 'directionsBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import rDirectionsBlock from './DirectionsBlock.jsx';
import React from 'react';
import ReactDOM from 'react-dom';
const defaultStartProps = {};
const defaultEndProps = {};

export class DirectionsBlock {
	constructor($el) {
		// $el is the blk node return by the loadDirectionsBlock function
		this.$el = $el;
	}

	init() {
		this.setDirectionsBlock();
	}

	setDirectionsBlock() {
		const country = $('body').hasClass('en-NZ')? 'nz': 'au';
		const element = document.getElementById('directionsBlock');
		const elementData = document.querySelector('#directionsBlock');

		const propsFromHtml = {
			title: elementData.dataset.title,
			buttonText: elementData.dataset.button,
			parkingLat: Number.parseFloat(elementData.dataset.parkinglat),
			parkingLng: Number.parseFloat(elementData.dataset.parkinglng),
			parkingName: elementData.dataset.parkingName,
			country: country,
		};

		ReactDOM.render(
			React.createElement(rDirectionsBlock, propsFromHtml), element);

		// ReactDOM.render(
		// 	React.createElement(rDirectionsBlock, defaultStartProps),
		// 	$(this.$el).find(BLK + 'startingLocation')[0]
		// );

		// // Add Some logic here
		// defaultStartProps.preventFetchingResults = true;
		// defaultStartProps.useCurrentLocation = true;

		// defaultEndProps.preventFetchingResults = true;

		// ReactDOM.render(
		// 	React.createElement(rDirectionsBlock, defaultStartProps),
		// 	$(this.$el).find(BLK + 'startingLocation')[0]
		// );

		// ReactDOM.render(
		// 	React.createElement(rDirectionsBlock, defaultEndProps),
		// 	$(this.$el).find(BLK + 'destination')[0]
		// );

		// $(this.$el).find(BLK + 'startingLocation input').attr('placeholder', 'Enter your starting location');
		// $(this.$el).find(BLK + 'destination input').attr('placeholder', 'Enter your destination');
	}

	// Add more functions like on above here
}
